import "./TheGarden.module.css";
import Header from "@/reusable_sections/Header";
import WorkshopsEvents from "./sections/WorkshopsEvents";
import MemberBenefits from "./sections/MemberBenefits";
import GardenFaq from "./sections/GardenFaq";
import Footer from "@/reusable_sections/Footer";
export default function TheGardenPage() {
  return <div>
      <Header />
      <WorkshopsEvents />
      <MemberBenefits />
      <GardenFaq />
      <Footer />
    </div>;
}